module.exports = __webpack_public_path__ + "static/media/pko_logo.16d0555f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pko_logo.webp
// module id = 646
// module chunks = 0